import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import withClientId from '@/hocs/with-client-id';
import { withRouter } from 'react-router-dom';
import { Row, Col, Select, Input, Button, Modal } from 'antd';
import RollCallTable from '@/pages/evacuation-demo/components/evacuation-roll-call-table';
import { Icon } from 'antd';

import './index.scss';
import { wsClient } from '@/index';
const Search = Input.Search;

const EvacuationRollCall = props => {
	// const [visible, showModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState('');
	const [holders, setHolders] = useState([]);
	const [count, setCount] = useState(5);
	const [sitesList, setSitesList] = useState(null);
	const [floorsList, setfloorsList] = useState(null);
	const [currentSite, setCurrentSite] = useState(null);
	const [isPageChange, setIsPageChange] = useState(false);
	const [currentFloor, setcurrentFloor] = useState(props.match.params.zoneId);

	useEffect(
		() => {
			let timer1 = setInterval(() => hendelCount(), 1000);
			function hendelCount() {
				if (count > 0 && typeof count === 'number') {
					setCount(count - 1);
				} else {
					setCount('timeout');
				}
			}
			setIsPageChange(false);
			if (count === 0) {
				fetchHolders();
			}
			// this will clear Timeout when component unmont like in willComponentUnmount
			return () => {
				clearInterval(timer1);
			};
		},
		[count, props.match.params.zoneId], //useEffect will run only one time
		//if you pass a value to array, like this [data] than clearTimeout will run every time this value changes (useEffect re-run)
	);
	useEffect(
		() => {
			fetchHolders();
			getSiteList(props.clientId, setSitesList);
			getFloorList(
				props.clientId,
				props.match.params.siteId,
				setfloorsList,
			);
			setCurrentSite(props.match.params.siteId);
			setIsPageChange(true);
		},
		[props.match.params.zoneId],
	);
	const fetchHolders = () => {
		setLoading(true);
		const {
			clientId,
			match: {
				params: { zoneId, siteId },
			},
		} = props;

		const requestPayload = {
			messageType: 'evacuation.evacuation.get-evacuation-area-holders',
			payload: {
				clientId,
				siteId,
				areaId: zoneId,
			},
		};

		wsClient.subscribe(requestPayload, response => {
			const { payload } = response;
			if (payload && Array.isArray(payload)) {
				setHolders(payload);
				setLoading(false);
				setCount(5);
			}
		});
	};

	function getSiteList(clientId, cb) {
		const params = {
			messageType: 'core.site.list-sites',
			payload: {
				clientId,
			},
		};
		wsClient.request(params, response => {
			const { payload } = response;
			if (payload && Array.isArray(payload)) {
				cb(payload);
			}
		});
	}
	function getFloorList(clientId, siteId, cb) {
		const params = {
			messageType: 'evacuation.evacuation.get-evacuation-areas',
			payload: {
				clientId,
				siteId,
			},
		};
		wsClient.request(params, response => {
			const { payload } = response;
			if (payload && Array.isArray(payload)) {
				cb(payload);
			}
		});
	}
	function onPageChangeCb(pagination) {
		setIsPageChange(true);
	}
	function handleSearch(search) {
		setSearch(search);
		setIsPageChange(true);
	}
	function handleFloor(f) {
		setcurrentFloor(f);
		props.history.push(`/evacuation/roll-call/test-site/${f}`);
	}

	return (
		<div className="evacuation-roll-call-wrapper">
			<Row
				className="top-nav"
				gutter={{ xs: 8, sm: 16, md: 40 }}
				type={'flex'}
				align={'middle'}
			>
				<Col xs={12} md={2}>
					<a onClick={() => props.history.push('/evacuation')}>
						&laquo; Back
					</a>
				</Col>
				<Col md={8} xs={24}>
					<Select
						defaultValue={currentSite}
						value={currentSite}
						style={{ width: '100%' }}
						disabled
					>
						{sitesList &&
							sitesList.map((site, index) => (
								<Select.Option key={index} value={site.siteId}>
									{`${site.description}, ${site.address}`}
								</Select.Option>
							))}
					</Select>
				</Col>
				<Col md={8} xs={24}>
					<Select
						defaultValue={currentFloor}
						value={currentFloor}
						style={{ width: '100%' }}
						onChange={f => handleFloor(f)}
					>
						{floorsList &&
							floorsList.map((floor, index) => (
								<Select.Option key={index} value={floor}>
									{floor}
								</Select.Option>
							))}
					</Select>
				</Col>
			</Row>
			<Row
				gutter={{ xs: 8, sm: 16, md: 40 }}
				type={'flex'}
				justify={'space-between'}
				align={'middle'}
			>
				<Col xs={24} md={6}>
					<Search
						placeholder="Search by name…"
						onChange={e => handleSearch(e.target.value)}
						value={search}
						style={{ width: 200 }}
					/>
				</Col>
				<Col xs={24} md={6} style={{ textAlign: 'right' }}>
					{count === 0 && <Icon type="loading" />}
					{count !== 'timeout'
						? ` ${count} sec to next update `
						: count}
				</Col>
				{/*<Col xs={24} md={6}>*/}
				{/*<Button*/}
				{/*type="primary"*/}
				{/*onClick={()=>showModal(true)}*/}
				{/*style={{ width: '100%' }}*/}
				{/*>*/}
				{/*filter*/}
				{/*</Button>*/}
				{/*</Col>*/}
			</Row>
			<RollCallTable
				data={holders}
				search={search}
				loading={loading}
				isPageChange={isPageChange}
				paginationChange={onPageChangeCb}
			/>
			<Row
				gutter={{ xs: 8, sm: 16, md: 40 }}
				type={'flex'}
				justify={'end'}
			>
				{/*<Col xs={24} md={6}>*/}
				{/*<Button style={{ width: '100%' }}>call</Button>*/}
				{/*</Col>*/}
				{/*<Col xs={24} md={6}>*/}
				{/*<Button style={{ width: '100%' }}>send message</Button>*/}
				{/*</Col>*/}
			</Row>
			{/*<Modal*/}
			{/*visible={visible}*/}
			{/*title="Title"*/}
			{/*onOk={this.handleOk}*/}
			{/*onCancel={() => showModal(false)}*/}
			{/*footer={*/}
			{/*<Button*/}
			{/*key="submit"*/}
			{/*type="primary"*/}
			{/*onClick={() => showModal(false)}*/}
			{/*>*/}
			{/*Apply filters*/}
			{/*</Button>*/}
			{/*}*/}
			{/*>*/}
			{/*<p>Some contents...</p>*/}
			{/*<p>Some contents...</p>*/}
			{/*<p>Some contents...</p>*/}
			{/*<p>Some contents...</p>*/}
			{/*<p>Some contents...</p>*/}
			{/*</Modal>*/}
		</div>
	);
};

export default compose(
	withClientId,
	withRouter,
)(EvacuationRollCall);



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/evacuation-roll-call/index.js